import { observer } from 'mobx-react-lite'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { AppButton } from 'src/component/common/analog/molecule/button/AppButton'
import { AppDivider } from 'src/component/common/analog/molecule/AppDivider'
import { ModalWindow } from 'src/component/common/analog/template/ModalWindow'
import { useLocalizationStore } from 'src/feature/localization/store/localization.store'
import { Paragraph } from 'src/feature/localization/component/atom/Paragraph'
import { BoolProps } from 'src/model/Boolean'

export interface DeleteConfirmationModalProps extends BoolProps {
  onConfirm: () => void
  title?: string
  description?: string
  isLoading?: boolean
}

export const DeleteConfirmationModal = observer((props: DeleteConfirmationModalProps) => {
  const { translation } = useLocalizationStore()
  
  const handleConfirm = () => {
    props.onConfirm()
    props.makeFalse()
  }

  return (
    <ModalWindow
      modalProps={{
        open: props.isTrue,
        onClose: props.makeFalse,
        PaperProps: {
          sx: {
            maxWidth: { xs: '80%', md: '50%', lg: '30%' },
            borderRadius: '10px',
          },
        },
      }}
      titleProps={{
        textValue: props.title || translation.pages.profile.certificationModal.deleteConfirmTitle(),
      }}
    >
      <AppBox sx={styles.container}>
        <Paragraph
          textValue={props.description || translation.pages.profile.certificationModal.deleteConfirmDescription()}
          m={5}
        />
        <AppDivider />
        <AppBox sx={styles.buttonContainer}>
          <AppButton
            fontSize={12}
            textValue={translation.buttons.cancel()}
            variant="light"
            onClick={props.makeFalse}
            disabled={props.isLoading}
          />
          <AppButton
            fontSize={12}
            textValue={translation.buttons.confirm()}
            variant="danger"
            onClick={handleConfirm}
            disabled={props.isLoading}
          />
        </AppBox>
      </AppBox>
    </ModalWindow>
  )
})

const styles = {
  container: {
    flexDirection: 'column',
    gap: 10,
  },
  buttonContainer: {
    gap: 10,
    justifyContent: 'flex-end',
  },
}